export enum TabsItem {
    ACTIVITY_REGISTER = "ACTIVITY_REGISTER",
    MY_ACTIVITY = "MY_ACTIVITY",
    PATH = "PATH",
    ACCESS = "ACCESS",
    CATALOG = "CATALOG",
    DAILYCUTS = "DAILYCUTS",
    DESTINATION_REGISTERED = "DESTINATION_REGISTERED"
}